import { ReactNode, lazy, Suspense } from "react";
import Navbar from "./Navbar";

// Below-the-fold — defer JS off the critical path to improve TTI.
const Footer = lazy(() => import("./Footer"));
const NewsletterCTA = lazy(() => import("@/components/newsletter/NewsletterCTA"));

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-screen flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Suspense fallback={null}>
      <NewsletterCTA />
      <Footer />
    </Suspense>
  </div>
);

export default Layout;
